import React from 'react'
import { Grid, Typography } from '@mui/material'
import MainCard from 'ui-component/cards/MainCard'

const FinanceRatna=()=> {
  return (
    <Grid>
      <Grid item xs={12}>
        <MainCard title="Ratna" >
          <Typography variant='h4' sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '65vh' }}>
            Something exciting is coming your way. Watch this space!!
          </Typography>
        </MainCard>
      </Grid>
    </Grid>
  )
}

export default FinanceRatna